module.exports = __webpack_public_path__ + "static/media/BH.6f0dac77.svg";